import { Injectable } from '@angular/core';
import {Square} from "../classes/Square";
import {MineClasses} from "../constants/MineClasses";
import {Board} from "../classes/Board";

@Injectable()
export class GameLogicService {

  constructor() { }

  checkIfMinePresent(board:Board, row:number, column:number){
    return board.squares[row][column].minePresent;
  }

  checkIfMarked(board:Board, row:number, column:number){
    return board.squares[row][column].marked;
  }

  checkNeighbors(row: number, column: number ,board:Board){
    let counter = 0;
    board.squares[row][column].viewClass = MineClasses.clickedWithNoMine; //change the css view class of clicked square
    board.squares[row][column].clicked = true;
    board.squaresRemaining-=1;

    //check for the number of neighboring squares containing mines
    for (var i = -1; i<2;i++){
      if(this.checkIfRowInBoard(row+i, board.height)) {
        let position = (row + i) * board.length + column;
        for (var j = -1; j<2;j++) {
          if (this.checkIfColumnInBoard(column+j,board.length)) {
            counter= board.squares[row+i][column+j].minePresent? counter+1 :counter;
          }
        }
      }
    }

    //if there are no mines in neighboring squares, then recursively call itself on all neighboring squares
    if(counter==0){
      for (var i = -1; i<2;i++){
        let position = (row + i) * board.length + column;
        if(this.checkIfRowInBoard(row+i, board.height) ) {
          for (var j = -1; j<2;j++) {
            if( this.checkIfColumnInBoard(column+j,board.length) && !this.checkIfsquareAccessed(board,row+i,column+j)){ // make sure column can be accessed and square has not already been checked
              board = this.checkNeighbors(row + i, column+j,board);
            }
          }
        }
      }
    }

    board.squares[row][column].neighborCount =  counter;
    return board;
  }

  addSquaresToBoard(board:Board, mineLocations:number[]){
    for(var i = 0; i< board.height;i++){
      let squareArray: Square[] = []; //row of squares
      for(var j = 0; j< board.length;j++) {
        let square: Square;
        if (mineLocations.includes(i*board.length+j)) { //if square should contain mine
          square = new Square(MineClasses.unClicked, -1, true, false,false);
          board.squaresRemaining-=1;
        } else {
          square = new Square(MineClasses.unClicked, -1, false, false,false);
        }
        squareArray.push(square);
      }
      board.squares.push(squareArray); //add row to array of squares
    }
    return board;
  }

  showAllMines(board:Board,winner:boolean){ // show all mines as loser or winner when game ends
    for(var i = 0; i<board.height;i++){
      for(var j = 0; j<board.length;j++){
        if(this.checkIfMinePresent(board,i,j)){
          if(!winner) {
            board.squares[i][j].viewClass = board.squares[i][j].marked? MineClasses.marked: MineClasses.clickedWithMine;
          }else{
            board.squares[i][j].viewClass = board.squares[i][j].marked? MineClasses.marked: MineClasses.clickedWithMineLost;
          }
        }else{

        }
      }
    }
    return board;
  }

  gameWon(board:Board){ // change view class of clicked squares when user wins
    for(var i = 0; i<board.height;i++){
      for(var j = 0; j<board.length;j++){
        if(!this.checkIfMinePresent(board,i,j)){
          board.squares[i][j].viewClass=  MineClasses.clickedAndGameOver;
        }
      }
    }
    board = this.showAllMines(board,true);
    return board;
  }


  gameLost(board:Board){ // change view class of clicked squares when user wins
    for(var i = 0; i<board.height;i++){
      for(var j = 0; j<board.length;j++){
        if(!this.checkIfMinePresent(board,i,j)){
          board.squares[i][j].viewClass= board.squares[i][j].marked? MineClasses.markedWrong: board.squares[i][j].viewClass;
        }
      }
    }
    board = this.showAllMines(board,false);
    return board;
  }

  markOrUnmarkSquare(row:number,column:number,board:Board){ // mark square
    board.squares[row][column].marked = !board.squares[row][column].marked;
    board.squares[row][column].viewClass = board.squares[row][column].marked? MineClasses.marked: MineClasses.unClicked;
    return board;
  }

  getMinePositions(board:Board){ // returns random locations for mines
    let mineLocations = [];
    for(var i = 0; i< board.numberOfMines;i++){
      let newPosition = this.getRandomInt(board.length*board.height);
      while(mineLocations.includes(newPosition)){
        newPosition = this.getRandomInt(board.length*board.height);
      }
      mineLocations.push(newPosition)
    }
    return mineLocations;
  }



  checkIfColumnInBoard(column, boardLength){
    return (column) >=0 && (column) < boardLength;
  }

  checkIfRowInBoard(row, boardHeight){
    return (row) >=0 && (row) < boardHeight;
  }

  checkIfsquareAccessed(board:Board,row:number,column:number){
    return board.squares[row][column].clicked;
  }

  getRandomInt(max:number){
    return Math.floor(Math.random() * Math.floor(max));
  }
}



// WEBPACK FOOTER //
// ./src/app/minesweeper/services/game-logic.service.ts